import React from 'react';
import { Card } from '@dopomogai/ui';

type FAQ = { q: string; a: string };
type Props = { faqs?: FAQ[] };

const DEFAULTS: FAQ[] = [
  { q: 'Is this tradable?', a: 'No. Units are non-transferable and not tradable. This is high risk.' },
  { q: 'How do payouts work?', a: 'From profits after costs, when available. Not guaranteed. See Terms.' },
  { q: 'Can I lose money?', a: 'Yes. There are no guarantees of returns. Invest responsibly.' },
];

export function InvestFAQ({ faqs = DEFAULTS }: Props) {
  return (
    <section className="max-w-4xl mx-auto px-6 py-12">
      <h2 className="text-2xl font-extrabold mb-4">Frequently asked questions</h2>
      <div className="space-y-3">
        {faqs.map((f, i) => (
          <Card key={i}>
            <div className="p-4">
              <div className="font-bold">{f.q}</div>
              <div className="text-slate-700 mt-1">{f.a}</div>
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
}


